export enum IncomingLabels {
  Date = "Date",
  Test = "Test",
  NoMatch = "No match",
  Received = "Received",
  PrintedBy = "Printed by",
  Unassigned = "Unassigned",
  DatePrinted = "Date printed",
  AddressedTo = "Addressed to",
  NotAddressed = "Not addressed",
  SearchFileName = "Search for file name",
  Subject = "Subject"
}
